import React, { useState, useEffect } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { i18n } from "./lang/i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import Footer from "./components/Footer";
import Navigation from "./components/Navigation";

import "./App.scss";
import Cart from "./components/Cart";
import { distributorQuick } from "./helpers/utils";
import { endpoints } from "./helpers/endpoints";

function App() {
  const [language, setLanguage] = useState("jp");
  const [searchParams, setSearchParams] = useSearchParams();
  const [langSelected, setLangSelected] = useState();
  const [wishlists, setWishlists] = useState([]);
  const [categorySelected, setCategorySelected] = useState("all");

  useEffect(() => {
    const lang = i18n.language;
    const category = searchParams.get("category");
    if (category && category !== "all") {
      setCategorySelected(category);
    }
    setLangSelected(lang);
  }, [searchParams]);

  const changeLanguage = (e) => {
    e.preventDefault();
    setLanguage(e.target.value);
    i18n.changeLanguage(e.target.value);
    searchParams.set("lang", e.target.value);
    setSearchParams(searchParams);
  };

  const removeWishlist = (item) => {
    const filtered = wishlists.filter((x) => {
      return x.Id !== item.Id;
    });

    setWishlists(filtered);
    localStorage.setItem("wishlists", JSON.stringify(filtered));
  };

  const goToTop = () => {
    window.scrollTo(0, 0);
  };

  const addWishlist = (item) => {
    setWishlists((sw) => [...sw, item]);
  };

  const wishlistInjection = () => {
    let products = [];

    wishlists.map((item) => {
      products = [...products, item.Id];
    });

    const favourites = {
      Favourites: products,
    };

    const brandingStyle = distributorQuick;
    const formData = [
      { name: "type", value: "SearchInjection" },
      { name: "data", value: JSON.stringify(favourites) },
      {
        name: "exl_dn",
        value: distributorQuick,
      },
      { name: "exl_bs", value: brandingStyle },
      { name: "exl_lng", value: language === "jp" ? "ja" : language + "-JP" },
      { name: "exl_cur", value: "JPY" },
      {
        name: "options",
        value: JSON.stringify({ OpenInNewWindow: true }),
      },
    ];

    const form = document.createElement("form");
    form.action = endpoints.injection;
    form.method = "POST";

    formData.forEach(function (item) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = item.name;
      input.value = item.value;

      form.appendChild(input);
    });

    document.body.appendChild(form);

    form.submit();

    document.body.removeChild(form);
  };

  return (
    <div className="App">
      <Navigation />
      <Outlet
        context={[
          language,
          wishlists,
          setWishlists,
          removeWishlist,
          categorySelected,
          setCategorySelected,
          wishlistInjection,
          addWishlist,
          changeLanguage,
          langSelected,
        ]}
      />
      <Cart
        category={categorySelected}
        language={language}
        wishlists={wishlists}
        removeWishlist={removeWishlist}
        wishlistInjection={wishlistInjection}
      />
      <div className="top" onClick={() => goToTop()}>
        <FontAwesomeIcon icon={faChevronUp} />
        <div>PageTop</div>
      </div>
      <ToastContainer />
      <Footer />
    </div>
  );
}

export default App;
